<template>
  <v-app>
    <Header ref="header"/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-right xs12>
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentEmployee" style="padding-bottom: 0 !important; width: 250px; float: left;"></v-text-field>
            <v-btn flat v-if="!currentEmployee" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentEmployee" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat @click="timeRegistrationExcelReportForAll" class="bw-8" v-if="!currentEmployee" :disabled="filterInactive">Time registration reports</v-btn>
            <v-btn flat v-if="!currentEmployee" @click="editNewEmployee" class="bw-7">Create new employee</v-btn>
            <div v-if="viewTimeRegistrations && !timeRegistration" style="float: left; padding-top: 4px; padding-left: 12px; height: 30px;">
              <table>
                <tr>
                  <td>
                    <v-menu v-model="timeRegistrationFromDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="timeRegistrationFromDate" prepend-icon="event" readonly style="width: 120px;" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="timeRegistrationFromDate" @input="timeRegistrationFromDateMenu = false" @change="loadTimeRegistrations"></v-date-picker>
                    </v-menu>
                  </td>
                  <td style="width: 60px;">&nbsp;</td>
                  <td>
                    <v-menu v-model="timeRegistrationToDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="timeRegistrationToDate" prepend-icon="event" readonly style="width: 120px;" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="timeRegistrationToDate" @input="timeRegistrationToDateMenu = false" @change="loadTimeRegistrations"></v-date-picker>
                    </v-menu>
                  </td>
                </tr>
              </table>
            </div>
            <v-btn flat @click="previousTimeRegistrationPeriod" class="bw-1" style="float: left; margin-left: 50px;" v-if="viewTimeRegistrations && !timeRegistration">&lt;</v-btn>
            <v-btn flat @click="nextTimeRegistrationPeriod" class="bw-1" style="float: left; margin-left: 5px;" v-if="viewTimeRegistrations && !timeRegistration">&gt;</v-btn>
            <v-btn flat @click="startViewTimeRegistrations" class="bw-6" style="float: left;" v-if="currentEmployee && currentEmployee.id > 0 && !viewTimeRegistrations">Time registrations</v-btn>
            <v-btn flat @click="timeRegistrationExcelReport" class="bw-3" v-if="viewTimeRegistrations && !timeRegistration && timeRegistrations.length > 0">Excel</v-btn>
            <v-btn flat @click="confirmBulkDeleteTimeRegistrationsDialog = true" class="bw-3" v-if="viewTimeRegistrations && !timeRegistration" :disabled="bulkDeleteTimeRegistrationsDisabled">Delete</v-btn>
            <v-btn flat @click="endViewTimeRegistrations" class="bw-3" v-if="viewTimeRegistrations && !timeRegistration">Close</v-btn>
            <v-btn flat @click="saveTimeRegistration" class="bw-3" v-if="inEditTimeRegistration">Save</v-btn>
            <v-btn flat @click="cancelTimeRegistration" class="bw-3" v-if="inEditTimeRegistration">Cancel</v-btn>
            <v-btn flat @click="editTimeRegistration" class="bw-3" v-if="viewTimeRegistrations && timeRegistration && !inEditTimeRegistration">Edit</v-btn>
            <v-btn flat @click="confirmDeleteTimeRegistrationDialog = true" class="bw-3" v-if="viewTimeRegistrations && timeRegistration && !inEditTimeRegistration">Delete</v-btn>
            <v-btn flat @click="closeTimeRegistration" class="bw-3" v-if="viewTimeRegistrations && timeRegistration && !inEditTimeRegistration">Close</v-btn>
            <v-btn flat v-if="currentEmployee && !viewTimeRegistrations" :disabled="saveButtonDisabled" v-on:click="save" class="bw-3">{{ currentEmployee.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="canResetAccessCode" @click="resetAccessCode" class="bw-6">Reset access code</v-btn>
            <v-btn flat v-if="canDelete" @click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentEmployee && !viewTimeRegistrations" @click="cancel" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentEmployee" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredEmployees" :search="search" hide-actions>
              <template v-slot:items="props">
                <tr @click="selectEmployee(props.item)" class="selectable">
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.legalEntity.nameAndType }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <Panel v-if="currentEmployee && !viewTimeRegistrations">
        <PanelColumn title="Employee">
          <v-flex xs4 sm3 md3>
            <v-label>Employee name</v-label>
          </v-flex>
          <v-flex xs6 sm6 md4>
            <v-text-field color="teal" v-model="currentEmployee.name" ref="name" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs2 sm3 md5/>

          <v-flex xs4 sm3 md3 style="line-height: 35px;">
            <v-label>Company</v-label>
          </v-flex>
          <v-flex xs8 sm9 md9>
            <v-autocomplete
              v-model="currentEmployee.legalEntity"
              :items="legalEntities"
              :menu-props="{ maxHeight: '300' }"
              item-text="nameAndType"
              return-object
            ></v-autocomplete>
          </v-flex>

          <v-flex xs4 sm3 md3 style="line-height: 35px;">
            <v-label>Inactive</v-label>
          </v-flex>
          <v-flex xs6 sm6 md4>
            <v-checkbox color="teal" v-model="currentEmployee.inactive"/>
          </v-flex>
          <v-flex xs2 sm3 md5/>
        </PanelColumn>
      </Panel>

      <Panel v-if="currentEmployee && viewTimeRegistrations">
        <PanelColumn :title="'Time registrations for ' + currentEmployee.name" v-if="!timeRegistration">
          <v-flex xs12>
            <v-container fluid py-0 px-0>
              <v-layout style="max-height: calc(100vh - 270px);">
                <v-flex style="overflow-y: auto;">
                  <v-data-table :headers="timeRegistrationHeaders" :items="timeRegistrations" hide-actions class="timeRegistrationTable" no-data-text="No time registration entries found">
                    <template v-slot:items="props">
                      <tr class="selectable timeRegistrations">
                        <td style="width: 10px; padding: 0 !important;"><v-checkbox color="#004d40" v-model="timeRegistrationsSelected[props.index].selected" style="padding: 0; width: 28px;"/></td>
                        <td @click="selectTimeRegistration(props.item)" class="text-xs-left" style="width: 100px;">{{ props.item.displayDate }}</td>
                        <td @click="selectTimeRegistration(props.item)" class="text-xs-left" style="width: 100px; padding-left: 20px !important;">{{ props.item.displayStartTime }}</td>
                        <td @click="selectTimeRegistration(props.item)" class="text-xs-left" style="width: 100px; padding-left: 16px !important;">{{ props.item.displayEndTime }}</td>
                        <td @click="selectTimeRegistration(props.item)" class="text-xs-right" style="width: 100px; padding-right: 25px !important;">{{ breakAsString(props.item.lunchBreak) }}</td>
                        <td @click="selectTimeRegistration(props.item)" class="text-xs-right" style="width: 100px;">{{ durationAsString(props.item.duration) }}</td>
                        <td @click="selectTimeRegistration(props.item)" class="text-xs-left" style="width: 35%"><div v-if="props.item.field" v-html="props.item.field.address.nameAndText"></div></td>
                        <td @click="selectTimeRegistration(props.item)" class="text-xs-left"><div v-if="props.item.task" v-html="props.item.task.title"></div></td>
                      </tr>
                    </template>
                    <template v-slot:footer>
                      <tr class="total">
                        <td class="total" colspan="4" style="padding-left: 10px;">Total</td>
                        <td class="total" style="text-align: right; padding-right: 10px;">{{ durationAsString(totalDuration) }}</td>
                        <td class="total" colspan="2"></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </PanelColumn>
        <PanelColumn :title="'Time registration for ' + currentEmployee.name" v-if="timeRegistration">
          <v-flex xs12>
            <v-container fluid py-0 px-0>
              <v-layout style="max-height: calc(100vh - 270px);">
                <v-flex style="overflow-y: auto;">
                  <v-container fluid py-0 px-0>
                    <v-layout wrap>
                      <v-flex xs12 sm4 md3 lg2>
                        <v-label>Date</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="!inEditTimeRegistration">
                        {{ timeRegistration.displayDate }}
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="inEditTimeRegistration">
                        <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="currentTimeRegistration.date" prepend-icon="event" readonly style="width: 120px;" v-on="on"/>
                          </template>
                          <v-date-picker v-model="currentTimeRegistration.date" @input="dateMenu = false"></v-date-picker>
                        </v-menu>

                      </v-flex>

                      <v-flex xs12 sm4 md3 lg2>
                        <v-label>Start time</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="!inEditTimeRegistration">
                        {{ timeRegistration.displayStartTime }}
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="inEditTimeRegistration">
                        <v-menu v-model="startTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="currentTimeRegistration.sTime" prepend-icon="access_time" readonly style="width: 85px" v-on="on"></v-text-field>
                          </template>
                          <v-time-picker v-if="startTimeMenu" v-model="currentTimeRegistration.sTime" :allowed-minutes="startAllowedSteps" class="mt-3" format="24hr" @click:minute="startTimeMenu = false"></v-time-picker>
                        </v-menu>
                      </v-flex>

                      <v-flex xs12 sm4 md3 lg2>
                        <v-label>End time</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="!inEditTimeRegistration">
                        {{ timeRegistration.displayEndTime }}
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="inEditTimeRegistration">
                        <v-menu v-model="endTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="currentTimeRegistration.eTime" prepend-icon="access_time" readonly style="width: 85px" v-on="on"></v-text-field>
                          </template>
                          <v-time-picker v-if="endTimeMenu" v-model="currentTimeRegistration.eTime" :allowed-minutes="endAllowedSteps" class="mt-3" format="24hr" @click:minute="endTimeMenu = false"></v-time-picker>
                        </v-menu>
                      </v-flex>

                      <v-flex xs12 sm4 md3 lg2>
                        <v-label>Break</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="!inEditTimeRegistration">
                        <div v-html="timeRegistration.lunchBreak > 0 ? timeRegistration.lunchBreak + ' mins' : ''"/>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="inEditTimeRegistration">
                        <table style="width: 100%;">
                          <tr>
                            <td style="width: 150px; vertical-align: top;">
                              <div style="width: 100px;">{{ currentTimeRegistration.lunchBreak }} minutes</div>
                            </td>
                            <td>
                              <v-slider hide-details v-model="currentTimeRegistration.lunchBreak" step="5" max="180" ticks style="max-width: 450px;"/>
                            </td>
                          </tr>
                        </table>
                      </v-flex>

                      <v-flex xs12 sm4 md3 lg2 v-if="!inEditTimeRegistration">
                        <v-label>Duration</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="!inEditTimeRegistration">
                        {{ durationAsString(timeRegistration.duration) }}
                      </v-flex>

                      <v-flex xs12 sm4 md3 lg2 :style="inEditTimeRegistration ? 'padding-top: 12px;' : ''">
                        <v-label>Field</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="!inEditTimeRegistration">
                        <div v-html="timeRegistration.field ? timeRegistration.field.address.nameAndText : ''"/>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="inEditTimeRegistration" style="padding-top: 12px;">
                        <v-select :items="fields" v-model="currentTimeRegistration.field" item-text="address.nameAndText" return-object class="timeRegistrationField"></v-select>
                      </v-flex>

                      <v-flex xs12 sm4 md3 lg2 :style="inEditTimeRegistration ? 'padding-top: 12px;' : ''">
                        <v-label>Task</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="!inEditTimeRegistration">
                        <div v-html="timeRegistration.task ? timeRegistration.task.title : ''"/>
                      </v-flex>
                      <v-flex xs12 sm8 md9 lg10 v-if="inEditTimeRegistration" style="padding-top: 12px;">
                        <v-select :items="tasks" v-model="currentTimeRegistration.task" item-text="title" return-object class="timeRegistrationTask"></v-select>
                      </v-flex>

                      <v-flex xs12 style="padding-top: 12px;" v-if="!inEditTimeRegistration">
                        <v-label>Changes</v-label>
                      </v-flex>
                      <v-flex xs12 v-if="!inEditTimeRegistration">
                        <v-data-table :headers="timeRegistrationLogHeaders" :items="timeRegistrationLogs" hide-actions class="timeRegistrationTable" no-data-text="No time registration log entries found">
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-xs-left" style="width: 150px;">{{ props.item.timestamp }}</td>
                              <td class="text-xs-left" style="width: 100px;">{{ props.item.displayDate }}</td>
                              <td class="text-xs-left" style="width: 100px; padding-left: 20px !important;">{{ props.item.displayStartTime }}</td>
                              <td class="text-xs-left" style="width: 100px; padding-left: 16px !important;">{{ props.item.displayEndTime }}</td>
                              <td class="text-xs-right" style="width: 100px; padding-right: 25px !important;"><div v-html="props.item.lunchBreak > 0 ? props.item.lunchBreak + ' mins' : ''"/></td>
                              <td class="text-xs-left" style="width: 35%"><div v-if="props.item.field" v-html="props.item.field.address.nameAndText"></div></td>
                              <td class="text-xs-left"><div v-if="props.item.task" v-html="props.item.task.title"></div></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>

                      <div v-if="inEditTimeRegistration" style="height: 25px;">&nbsp;</div>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </PanelColumn>
      </Panel>
    </v-content>
    <Footer/>

    <v-dialog v-model="showAccessCodeDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Access code</v-card-title>
        <v-card-text v-if="accessCode">The access code is '{{ accessCode }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeAccessCodeDialog">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete employee</v-card-title>
        <v-card-text v-if="currentEmployee">Are you sure you want to delete '{{ currentEmployee.name }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmBulkDeleteTimeRegistrationsDialog" persistent width="420">
      <v-card pa-5>
        <v-card-title class="headline">Delete time registrations</v-card-title>
        <v-card-text>Are you sure you want to delete {{ numberOfTimeRegistrationsSelected }} time registration{{ numberOfTimeRegistrationsSelected > 1 ? 's' : '' }}?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="bulkDeleteTimeRegistration">Yes</v-btn>
          <v-btn flat @click="confirmBulkDeleteTimeRegistrationsDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteTimeRegistrationDialog" persistent width="550">
      <v-card pa-5>
        <v-card-title class="headline">Delete time registration</v-card-title>
        <v-card-text v-if="timeRegistration">Are you sure you want to delete time registration for '{{ timeRegistration.displayDate }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteTimeRegistration">Yes</v-btn>
          <v-btn flat @click="confirmDeleteTimeRegistrationDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import DateUtil from '@/assets/javascript/dateutil'
import axios from 'axios'
import uuid from 'uuid/v4'

export default {
  name: 'Employees',
  components: { Header, Sidebar, Footer, Panel, PanelColumn },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Employee name', value: 'name', sortable: true },
        { text: 'Company', value: 'legalEntity', sortable: false }
      ],
      timeRegistrationHeaders: [
        { text: '', value: '', sortable: false },
        { text: 'Date', value: 'date', sortable: false },
        { text: 'Start time', value: 'startTime', sortable: false },
        { text: 'End time', value: 'endTime', sortable: false },
        { text: 'Break', value: 'lunchBreak', sortable: false },
        { text: 'Total', value: 'duration', sortable: false, align: 'end' },
        { text: 'Field', value: 'field', sortable: false },
        { text: 'Task', value: 'task', sortable: false }
      ],
      timeRegistrationLogHeaders: [
        { text: 'Timestamp', value: 'timestamp', sortable: false },
        { text: 'Date', value: 'displayDate', sortable: false },
        { text: 'Start time', value: 'displayStartTime', sortable: false },
        { text: 'End time', value: 'displayEndTime', sortable: false },
        { text: 'Break', value: 'lunchBreak', sortable: false },
        { text: 'Field', value: 'field', sortable: false },
        { text: 'Task', value: 'task', sortable: false }
      ],
      employees: [],
      currentEmployee: null,
      accessCode: '',
      showAccessCodeDialog: false,
      timeRegistrationsSelected: [],
      confirmDeleteDialog: false,
      confirmBulkDeleteTimeRegistrationsDialog: false,
      confirmDeleteTimeRegistrationDialog: false,
      legalEntities: [],
      timeRegistrations: [],
      viewTimeRegistrations: false,
      timeRegistration: null,
      currentTimeRegistration: null,
      timeRegistrationLogs: [],
      timeRegistrationFromDateMenu: false,
      timeRegistrationFromDate: '',
      timeRegistrationToDateMenu: false,
      timeRegistrationToDate: '',
      filterInactive: false,
      dateMenu: false,
      startTimeMenu: false,
      endTimeMenu: false,
      fields: [],
      tasks: []
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'employees' })
    this.loadEmployees()
  },
  computed: {
    saveButtonDisabled: function () {
      return !this.currentEmployee || this.currentEmployee.name.trim() === '' || !this.currentEmployee.legalEntity
    },
    canResetAccessCode: function () {
      return this.currentEmployee && this.currentEmployee.id > 0 && !this.viewTimeRegistrations
    },
    canDelete: function () {
      return this.currentEmployee && this.currentEmployee.id > 0 && !this.viewTimeRegistrations
    },
    totalDuration: function () {
      if (this.timeRegistrations && this.timeRegistrations.length) {
        let totalDuration = 0
        for (let timeregistration of this.timeRegistrations) {
          if (timeregistration.duration && timeregistration.duration > 0) {
            totalDuration += timeregistration.duration
          }
        }
        return totalDuration
      }
      return null
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredEmployees () {
      return this.employees.filter(c => this.filterInactive ? c.inactive : !c.inactive)
    },
    bulkDeleteTimeRegistrationsDisabled: function () {
      if (this.timeRegistrationsSelected) {
        for (let tr of this.timeRegistrationsSelected) {
          if (tr.selected) {
            return false
          }
        }
      }
      return true
    },
    numberOfTimeRegistrationsSelected: function () {
      let count = 0
      for (let tr of this.timeRegistrationsSelected) {
        count += tr.selected ? 1 : 0
      }
      return count
    },
    inEditTimeRegistration: function () {
      return this.currentTimeRegistration !== null
    }
  },
  methods: {
    startAllowedSteps: m => m % 5 === 0,
    endAllowedSteps: m => m % 5 === 0,
    loadEmployees () {
      axios.get('/backend/rest/employee/all')
        .then(response => {
          let employees = response.data
          for (let employee of employees) {
            if (employee.legalEntity && employee.legalEntity.inactive) {
              employee.legalEntity.nameAndType = employee.legalEntity.nameAndType + ' - (inactive)'
            }
          }
          this.employees = employees
        })
    },
    selectEmployee (item) {
      for (let e of this.employees) {
        if (e.id === item.id) {
          this.currentEmployee = e
          break
        }
      }
      this.loadLegalEntities()
    },
    editNewEmployee () {
      this.currentEmployee = {
        id: 0,
        name: '',
        legalEntity: null
      }
      this.loadLegalEntities()
      this.$nextTick(() => this.$refs.name.focus())
    },
    save () {
      axios.post('/backend/rest/employee', this.currentEmployee)
        .then((response) => {
          let employee = response.data
          if (employee.accessCode && employee.accessCode !== '') {
            this.accessCode = employee.accessCode
            this.openAccessCodeDialog()
          } else {
            this.loadEmployees()
            this.currentEmployee = null
          }
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })
    },
    delete () {
      axios.delete('/backend/rest/employee/' + this.currentEmployee.id)
        .then((response) => {
          this.loadEmployees()
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })

      this.confirmDeleteDialog = false
      this.currentEmployee = null
    },
    deleteTimeRegistration () {
      axios.delete('/backend/rest/time_registration/' + this.timeRegistration.id)
        .then(() => {
          this.confirmDeleteTimeRegistrationDialog = false
          this.closeTimeRegistration()
          this.loadTimeRegistrations()
        })
    },
    async bulkDeleteTimeRegistration () {
      for (let timeRegistrationSelected of this.timeRegistrationsSelected) {
        if (timeRegistrationSelected.selected) {
          await axios.delete('/backend/rest/time_registration/' + timeRegistrationSelected.timeRegistration.id)
        }
      }
      this.confirmBulkDeleteTimeRegistrationsDialog = false
      this.loadTimeRegistrations()
    },
    resetAccessCode () {
      axios.post('/backend/rest/employee/reset_access_code/' + this.currentEmployee.id)
        .then((response) => {
          let employee = response.data
          if (employee.accessCode && employee.accessCode !== '') {
            this.accessCode = employee.accessCode
            this.openAccessCodeDialog()
          } else {
            this.loadEmployees()
            this.currentEmployee = null
          }
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })
    },
    cancel () {
      this.currentEmployee = null
    },
    openAccessCodeDialog () {
      this.showAccessCodeDialog = true
    },
    closeAccessCodeDialog () {
      this.showAccessCodeDialog = false
      this.loadEmployees()
      this.currentEmployee = null
    },
    loadLegalEntities () {
      axios.get('/backend/rest/legal_entity')
        .then(response => {
          let legalEntities = response.data
          legalEntities = legalEntities.filter(le => !le.inactive || (this.currentEmployee && this.currentEmployee.legalEntity && this.currentEmployee.legalEntity.id === le.id))
          for (let legalEntity of legalEntities) {
            if (legalEntity.inactive) {
              legalEntity.nameAndType = legalEntity.nameAndType + ' - (inactive)'
            }
          }
          this.legalEntities = legalEntities
        })
    },
    loadTimeRegistrations () {
      this.timeRegistrationsSelected = []
      axios.get('/backend/rest/time_registration/employee/' + this.currentEmployee.id + '?from=' + this.timeRegistrationFromDate + '&to=' + this.timeRegistrationToDate)
        .then(response => {
          this.timeRegistrations = response.data

          if (this.timeRegistrations && this.timeRegistrations.length) {
            for (let timeRegistration of this.timeRegistrations) {
              this.timeRegistrationsSelected.push({
                id: timeRegistration.id,
                timeRegistration: timeRegistration,
                selected: false
              })
            }
          }
        })
        .catch(() => {
          this.timeRegistrations = []
        })
    },
    async loadFields () {
      if (this.currentEmployee) {
        await axios.get('/backend/rest/field/time_registration/employee/' + this.currentEmployee.id)
          .then(response => {
            this.fields = response.data
          })
          .catch(() => {
            this.fields = []
          })
      }
    },
    async loadTasks () {
      axios.get('/backend/rest/employee/task')
        .then(response => {
          this.tasks = response.data
        })
        .catch(() => {
          this.tasks = []
        })
    },
    async startViewTimeRegistrations () {
      // Load time registrations for the employee
      let from = new Date()
      let fromTime = DateUtil.datetimeToString(from)
      await axios.get('/backend/rest/time_registration/period/current')
        .then(response => {
          fromTime = response.data
        })
      this.timeRegistrationFromDate = DateUtil.datetimeToDate(fromTime)
      let to = new Date(this.timeRegistrationFromDate.valueOf())
      to.setMonth(to.getMonth() + 1)
      to.setDate(to.getDate() - 1)
      let toTime = DateUtil.datetimeToString(to)
      this.timeRegistrationToDate = DateUtil.datetimeToDate(toTime)

      await this.loadTimeRegistrations()
      this.timeRegistration = null
      this.viewTimeRegistrations = true
    },
    async previousTimeRegistrationPeriod () {
      let from = DateUtil.timeStringToDate(this.timeRegistrationFromDate)
      from.setMonth(from.getMonth() - 1)
      let fromTime = DateUtil.datetimeToString(from)
      this.timeRegistrationFromDate = DateUtil.datetimeToDate(fromTime)
      let to = new Date(this.timeRegistrationFromDate.valueOf())
      to.setMonth(to.getMonth() + 1)
      to.setDate(to.getDate() - 1)
      let toTime = DateUtil.datetimeToString(to)
      this.timeRegistrationToDate = DateUtil.datetimeToDate(toTime)

      await this.loadTimeRegistrations()
      this.timeRegistration = null
      this.viewTimeRegistrations = true
    },
    async nextTimeRegistrationPeriod () {
      let from = DateUtil.timeStringToDate(this.timeRegistrationFromDate)
      from.setMonth(from.getMonth() + 1)
      let fromTime = DateUtil.datetimeToString(from)
      this.timeRegistrationFromDate = DateUtil.datetimeToDate(fromTime)
      let to = new Date(this.timeRegistrationFromDate.valueOf())
      to.setMonth(to.getMonth() + 1)
      to.setDate(to.getDate() - 1)
      let toTime = DateUtil.datetimeToString(to)
      this.timeRegistrationToDate = DateUtil.datetimeToDate(toTime)

      await this.loadTimeRegistrations()
      this.timeRegistration = null
      this.viewTimeRegistrations = true
    },
    endViewTimeRegistrations () {
      this.viewTimeRegistrations = false
    },
    async editTimeRegistration () {
      await this.loadFields()
      await this.loadTasks()

      this.currentTimeRegistration = JSON.parse(JSON.stringify(this.timeRegistration))
      if (this.currentTimeRegistration.displayDate && this.currentTimeRegistration.displayDate !== '') {
        this.currentTimeRegistration.date = this.displayDateToDate(this.currentTimeRegistration.displayDate)
      }
      this.currentTimeRegistration.sTime = this.currentTimeRegistration.displayStartTime
      this.currentTimeRegistration.eTime = this.currentTimeRegistration.displayEndTime
    },
    saveTimeRegistration () {
      let timeRegistration = {
        id: this.currentTimeRegistration.id,
        employee: JSON.parse(JSON.stringify(this.currentTimeRegistration.employee)),
        field: JSON.parse(JSON.stringify(this.currentTimeRegistration.field)),
        task: JSON.parse(JSON.stringify(this.currentTimeRegistration.task)),
        startTime: this.currentTimeRegistration.date + ' ' + this.currentTimeRegistration.sTime,
        endTime: this.currentTimeRegistration.date + ' ' + this.currentTimeRegistration.eTime,
        lunchBreak: this.currentTimeRegistration.lunchBreak
      }
      axios.post('/backend/rest/time_registration', timeRegistration)
        .then(response => {
          this.timeRegistration = response.data
          this.loadTimeRegistrationLogs()
          this.loadTimeRegistrations()
        })
      this.currentTimeRegistration = null
    },
    cancelTimeRegistration () {
      this.currentTimeRegistration = null
    },
    breakAsString (breakMinutes) {
      let breakAsString = ''
      if (breakMinutes && breakMinutes > 0) {
        breakAsString = breakMinutes + ' min'
      }
      return breakAsString
    },
    durationAsString (durationMinutes) {
      let durationAsString = ''
      if (durationMinutes && durationMinutes > 0) {
        durationAsString = (durationMinutes / 60).toFixed(2) + ' hrs'
      }
      return durationAsString
    },
    selectTimeRegistration (timeRegistration) {
      this.timeRegistration = timeRegistration
      this.loadTimeRegistrationLogs()
    },
    closeTimeRegistration () {
      this.timeRegistration = null
    },
    loadTimeRegistrationLogs () {
      this.timeRegistrationLogs = []
      axios.get('/backend/rest/time_registration/' + this.timeRegistration.id + '/logs')
        .then(response => {
          this.timeRegistrationLogs = response.data
        })
    },
    timeRegistrationExcelReport () {
      let url = '/backend/report/timeRegistrationReport?employeeId=' + this.currentEmployee.id + '&from=' + this.timeRegistrationFromDate + '&to=' + this.timeRegistrationToDate + '&uuid=' + uuid()
      window.open(url)
    },
    timeRegistrationExcelReportForAll () {
      let url = '/backend/report/timeRegistrationReport?uuid=' + uuid()
      window.open(url)
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    },
    displayDateToDate (dateStr) {
      const [day, month, year] = dateStr.split('-')
      return DateUtil.dateToString(new Date(year, month - 1, day))
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .v-input__slot {
    height: 200px !important;
  }
  .timeRegistrationLogTable table.v-table thead tr {
    height: 24px !important;
  }
  .timeRegistrationLogTable table.v-table tbody td {
    height: 24px !important;
  }
  tr.total,
  td.total {
    font-weight: bold;
    font-size: 13px;
    cursor: default !important;
    line-height: 24px !important;
    height: 24px !important;
  }
  tr.timeRegistrations td {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Employees.vue